import { render } from "./MerchantUploadPage.vue?vue&type=template&id=35ad2009"
import script from "./MerchantUploadPage.vue?vue&type=script&lang=js"
export * from "./MerchantUploadPage.vue?vue&type=script&lang=js"
script.render = render

export default script